import React, { useEffect, useState } from 'react';
import NewUserInfo from '../../Main/NewUserInfo';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import styles from '../../Main/main.styles';
import axios from 'axios';
import { capitalize, isEmpty } from 'lodash';
import EmergencyButton from '../Components/EmergencyButton';
import useStore from '../../Store/Store';
import './CareRecipients.css';
import GirlImage from '../../images/girl.png';
import BoyImage from '../../images/boy.png';
import { useNavigate, useParams } from 'react-router-dom';
import General from './components/General';
import Diagnoses from './components/Diagnoses';
import Allergies from './components/Allergies';
import Instructions from './components/Instructions';
import Medicines from './components/Medicines';
import Documents from './components/Documents';
import HealthInsurance from './components/HealthInsurance';
import DoctorContact from './components/DoctorContact';
import Integrations from './components/Integrations';
import SideBar from '../../components/SideBar';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()(styles);

const CareRecipientDetailScreen = () => {
  const { t } = useTranslation();
  const { userId } = useParams();
  const history = useNavigate();
  const careRecipientId = userId;
  const { classes } = useStyles();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);

  const [recipient, setRecipient] = useState(null);
  const [activeTab, setActiveTab] = useState('General');

  const TAB_MENU = [
    t('general'),
    t('diagnoses'),
    t('allergies'),
    t('instructions'),
    t('medicines'),
    t('documents'),
    t('healthInsurance'),
    t('doctorContact'),
    t('integrations'),
  ];

  const TabContent = {
    [t('general')]: ({ user, recipient, refetchRecipient }) => (
      <General user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('diagnoses')]: ({ user, recipient, refetchRecipient }) => (
      <Diagnoses user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('allergies')]: ({ user, recipient, refetchRecipient }) => (
      <Allergies user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('instructions')]: ({ user, recipient, refetchRecipient }) => (
      <Instructions user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('medicines')]: ({ user, recipient, refetchRecipient }) => (
      <Medicines user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('documents')]: ({ user, recipient, refetchRecipient }) => (
      <Documents user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('healthInsurance')]: ({ user, recipient, refetchRecipient }) => (
      <HealthInsurance user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('doctorContact')]: ({ user, recipient, refetchRecipient }) => (
      <DoctorContact user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
    [t('integrations')]: ({ user, recipient, refetchRecipient }) => (
      <Integrations user={user} recipient={recipient} refetchRecipient={refetchRecipient} />
    ),
  };

  const getCareRecipientDetails = React.useCallback(async () => {
    try {
      const { data } = await axios.get(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/careRecipient/${careRecipientId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        },
      );

      setRecipient(data?.data);
    } catch (error) {
      console.log(error);
      history.goBack();
    }
  }, [careRecipientId, history, user?._id]);

  React.useEffect(() => {
    if (user) {
      getCareRecipientDetails();
    }
  }, [user, getCareRecipientDetails]);

  const ActiveTabComponent = TabContent[activeTab];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <div className="flex-column-a" style={{ left: width > 850 ? '14%' : '0%' }}>
            <span className="bread-cramb" onClick={() => history.goBack()}>
              {t('careRecipients')}{' '}
            </span>
            <span className="bread-cramb">/ {recipient?.fullName || ''}</span>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              className="caregivers-div"
              style={{ marginTop: '20px' }}
            >
              <Grid sm={12} lg={6} md={6} xs={12} container>
                <img
                  src={
                    !isEmpty(recipient?.userInfo?.imageUrl)
                      ? recipient?.userInfo?.imageUrl
                      : recipient?.userInfo?.gender === 'female'
                        ? GirlImage
                        : BoyImage
                  }
                  alt="image"
                  className="cg-image"
                />
                <div style={{ marginLeft: '20px' }}>
                  <h2>
                    {recipient?.userInfo?.firstName} {recipient?.userInfo?.lastName || ''}
                  </h2>
                  <span className="cg-phone-email">
                    {capitalize(t(recipient?.userInfo?.gender?.toLowerCase() || ''))}
                  </span>
                  <span className="cg-phone-email">
                    {recipient?.userInfo?.age && `${recipient?.userInfo?.age} ${t('yearsOld')}`}
                  </span>
                </div>
              </Grid>
              <Grid sm={12} lg={6} md={6} xs={12} style={{ display: 'flex', justifyContent: 'end' }}>
                <Grid className="health-box">
                  <small>{t('weight')}</small>
                  <span className="bold">{recipient?.userInfo?.weight || ''}</span>
                </Grid>
                <Grid className="health-box">
                  <small>{t('height')}</small>
                  <span className="bold">{recipient?.userInfo?.height || ''}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid container className="tab-menu">
              {TAB_MENU.map((item, idx) => (
                <Grid
                  key={idx}
                  className="tab-menu-item"
                  style={{ background: activeTab === item ? '#fff' : 'inherit' }}
                  onClick={() => handleTabClick(item)}
                >
                  {item}
                </Grid>
              ))}
            </Grid>

            {ActiveTabComponent && (
              <ActiveTabComponent user={user} recipient={recipient} refetchRecipient={getCareRecipientDetails} />
            )}
          </div>

          <EmergencyButton />
        </div>
      </div>
    </>
  );
};

export default CareRecipientDetailScreen;
